import { backendApi } from "./backend.api";
import { ISpace } from "shared/models/models";

export interface ISpaceListQuery {
  ownerId?: number;
}

const baseURL = "/space";
const cashTag = "Space";
type IResponse = ISpace;
export const countryApi = backendApi.injectEndpoints({
  endpoints: (build) => {
    return {
      spaces: build.query<IResponse[], ISpaceListQuery>({
        query: (queryParams) => ({
          url: baseURL,
          method: "GET",
          params: queryParams,
        }),
        providesTags: (result, error, arg) =>
          result?.length
            ? [
                ...result?.map(({ id }) => ({
                  type: `${cashTag}` as const,
                  id,
                })),
                cashTag,
              ]
            : [cashTag],
      }),
      getSpace: build.query<IResponse, number>({
        query: (id) => ({ url: `${baseURL}/${id}`, method: "GET" }),
        transformErrorResponse: (response: { route: string | number }) =>
          response.route,
        providesTags: (item) => [{ type: cashTag, id: item?.id }],
      }),
      addSpace: build.mutation<IResponse, Partial<IResponse>>({
        query: (payload) => ({
          url: baseURL,
          method: "POST",
          data: payload,
        }),
        invalidatesTags: () => [cashTag],
        transformResponse: (response: { data: IResponse }) => response.data,
      }),
      updateSpace: build.mutation<IResponse, Partial<IResponse>>({
        query: (payload) => ({
          url: `${baseURL}/${payload.id}`,
          method: "PATCH",
          data: payload,
        }),
        invalidatesTags: (item) => [{ type: cashTag, id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      deleteSpace: build.mutation<IResponse, number>({
        query: (id) => ({
          url: `${baseURL}/${id}`,
          method: "DELETE",
          credentials: "include",
        }),
        invalidatesTags: [cashTag],
      }),
    };
  },
});

export const {
  useSpacesQuery,
  useGetSpaceQuery,
  useUpdateSpaceMutation,
  useAddSpaceMutation,
  useDeleteSpaceMutation,
} = countryApi;
